import { render } from "./AppContainer.vue?vue&type=template&id=01b6707d"
import script from "./AppContainer.vue?vue&type=script&lang=js"
export * from "./AppContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__